import { render, staticRenderFns } from "./KeepAliveWidgetManager.vue?vue&type=template&id=2d7a9b72&scoped=true"
import script from "./KeepAliveWidgetManager.vue?vue&type=script&lang=js"
export * from "./KeepAliveWidgetManager.vue?vue&type=script&lang=js"
import style0 from "./KeepAliveWidgetManager.vue?vue&type=style&index=0&id=2d7a9b72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7a9b72",
  null
  
)

export default component.exports